const exportKey = {
    pembayaran: {
        tracker: "export:job:keuangan:saldodanpembayaranedc",
        job: "list_saldo_dan_pembayaran_edc",
    },
    listPembayaran: {
        tracker: "export:job:keuangan:detailpembayaransettlement",
        job: "detail_pembayaran_settlement_edc",
    },
    settlement: {
        tracker: "export:job:keuangan:riwayatsettlement",
        job: "riwayat_settlement_edc",
    },
};

export default exportKey;
